import { useParams } from "react-router-dom";
import { ResourceGroup } from "../features/resourceGroup";

const ResourceGroupPage = () => {
  const prms = useParams();
  const subscriptionId = prms.subscriptionId ?? "";
  const resourceGroupId = prms.resourceGroupId ?? "";

  return <ResourceGroup subscriptionId={subscriptionId} resourceGroupId={resourceGroupId} />;
};

export default ResourceGroupPage;
